module.exports = __webpack_public_path__ + "img/11_106.9124738f.png";